import { BUTTON_VARIANTS } from 'ui/button/constants';
import { LongArrowLeft } from 'ui/icons/navigation/LongArrowLeft';
import { LongArrowRight } from 'ui/icons/navigation/LongArrowRight';
import { PaginationVariant } from './types';
import { PaginationArrow } from './Styled';

type ArrowButtonProps = {
  direction: 'left' | 'right';
  page: number;
  pages: number;
  onChangePage: (page: number) => void;
  pageVariant: PaginationVariant;
};

export const ArrowButton = ({
  direction,
  page,
  pages,
  onChangePage,
  pageVariant = PaginationVariant.Purple,
}: ArrowButtonProps) =>
  direction === 'left' ? (
    <PaginationArrow
      aria-label="pagination-back"
      data-test="pagination-left-arrow"
      variant={BUTTON_VARIANTS.GHOST}
      isDisabled={page <= 1}
      onClick={() => page !== 1 && onChangePage(page - 1)}
      pageVariant={pageVariant}
    >
      <LongArrowLeft aria-hidden="true" />
    </PaginationArrow>
  ) : (
    <PaginationArrow
      aria-label="pagination-next"
      data-test="pagination-right-arrow"
      variant={BUTTON_VARIANTS.GHOST}
      isDisabled={page === pages || pages <= 1}
      onClick={() => page !== pages && onChangePage(page + 1)}
      pageVariant={pageVariant}
    >
      <LongArrowRight aria-hidden="true" />
    </PaginationArrow>
  );
